module.exports = __webpack_public_path__ + "img/midfoot_strike.a55e9747.svg";